import CheckboxGroup from '../checkbox/src/checkbox-group.vue';


CheckboxGroup.install = function(Vue) {
  Vue.component(CheckboxGroup.name, CheckboxGroup);
};

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/checkbox-group/index.js